import { useState } from "preact/hooks";
import {
  GET,
  GET_RESERVATION_LIST,
  GET_RESERVATION_LIST_QURRY,
} from "../../../services";
import { useMessage } from "../../../hooks/useMessage";
import { convertDateTimeThailand } from "../../../functions";
import { IStateReservation } from "../interfaces/state";

export const useGetData = () => {
  const { openMessage } = useMessage();
  const [data, setData] = useState([] as IStateReservation[]);

  const onFetchData = async () => {
    try {
      const res = await GET(GET_RESERVATION_LIST);
      const { reservations } = res.result;
      const items: IStateReservation[] = reservations.map(
        (e: IStateReservation, i: number) => ({
          ...e,
          index: i + 1,
          createDate: convertDateTimeThailand(e.createDate),
        })
      );
      setData(items);
    } catch (error) {
      console.log(error);
    }
  };

  const onSearch = async (qurryString: any) => {
    try {
      const res = await GET(GET_RESERVATION_LIST_QURRY(qurryString));
      const { reservations } = res.result;
      const items: IStateReservation[] = reservations.map(
        (e: IStateReservation, i: number) => ({
          ...e,
          index: i + 1,
          createDate: e.createDate
            ? convertDateTimeThailand(e.createDate)
            : null,
        })
      );
      setData(items);
      if (items.length === 0) {
        openMessage("error", "ไม่พบข้อมูล");
      }
      if (items.length > 0) {
        openMessage("success", res.message);
      }
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.message);
    }
  };

  return {
    data,
    setData,
    onFetchData,
    onSearch,
  };
};
